import { inject, Injectable } from '@angular/core';
import { AuthState, WebSocketChat, WebsocketClientService } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { MCAAuthState } from '@shared/data';
import { combineLatest, filter, first, map, Observable, of, switchMap } from 'rxjs';
import { MessagingAdapterBase } from './messaging-adapter.base';

@Injectable({ providedIn: 'root' })
export class WsMessagingAdapterService extends MessagingAdapterBase {
    private readonly wsService = inject(WebsocketClientService);
    private readonly store = inject(Store);
    guid!: string;

    constructor() {
        super();
    }

    initWebSocket(bookingId: string | undefined): Observable<void> {
        if (bookingId) {
            this.guid = bookingId;
        }

        if (this.wsService['channels'] && this.wsService['channels'][this.guid] && this.wsService['channels'][this.guid].activeWS) {
            return of(undefined);
        }

        return combineLatest([
            this.store.select(MCAAuthState.userInfo$).pipe(
                filter(userInfo => !!userInfo?.id),
                map(userInfo => userInfo?.id),
            ),
            this.store.select(AuthState.tokenData$).pipe(
                filter(tokenData => !!tokenData?.value?.accessTokenV2),
                map(tokenData => tokenData?.value?.accessTokenV2),
            ),
        ]).pipe(
            first(),
            switchMap(([userId, accessToken]) => {
                return this.wsService.initWebSocket(this.guid, userId, accessToken);
            }),
            map(() => undefined),
        );
    }

    getChatData() {
        return this.wsService.getChatData(this.guid);
    }

    sendMessage(message: WebSocketChat) {
        this.wsService.sendChatSocketMessage(this.guid, message.message, [message.document]);
    }

    closeSocket(bookingId: string | undefined) {
        if (!bookingId) {
            return;
        }
        this.wsService.closeSocket(bookingId);
    }
}
